import { request } from './http'

export function fetchNewsArticles(keyword = '') {
  const q = keyword ? `?keyword=${encodeURIComponent(keyword)}` : ''
  return request(`/api/admin/news${q}`)
}

export function createNewsArticle(data) {
  return request('/api/admin/news', {
    method: 'POST',
    body: JSON.stringify(data)
  })
}

export function updateNewsArticle(id, data) {
  return request(`/api/admin/news/${id}`, {
    method: 'PUT',
    body: JSON.stringify(data)
  })
}

export function deleteNewsArticle(id) {
  return request(`/api/admin/news/${id}`, {
    method: 'DELETE'
  })
}

export function fetchPublicNews() {
  return request('/api/news')
}

export function fetchPublicNewsItem(id) {
  return request(`/api/news/${id}`)
}

export function newsContentToParagraphs(content) {
  if (!content) return []
  const normalized = String(content).replace(/\r\n/g, '\n').replace(/\r/g, '\n')
  return normalized
    .split(/\n{2,}/)
    .map((p) => p.trim())
    .filter(Boolean)
}

function joinNewsLines(prev, next) {
  const needsSpace = /[A-Za-z0-9]$/.test(prev) && /^[A-Za-z0-9]/.test(next)
  return needsSpace ? `${prev} ${next}` : `${prev}${next}`
}

function shouldMergeNewsLines(prev, next) {
  if (!prev || !next) return false
  if (/^(\d+[.)、]|[-•*●○·▪])\s*/.test(next)) return false
  if (/[.!?。！？:：;；)\]】」›»"'"]\s*$/.test(prev)) return false
  if (next.length <= 48 && /[：:]\s*$/.test(next)) return false
  if (prev.length <= 56 && next.length <= 56) return false
  if (prev.length >= 36 && !/[.!?。！？]\s*$/.test(prev)) return true
  return false
}

/** Turn one paragraph into display lines; merges mid-sentence paste wraps. */
export function newsParagraphToDisplayLines(paragraph) {
  if (!paragraph) return []
  const rawLines = paragraph.split('\n').map((l) => l.trim()).filter(Boolean)
  if (rawLines.length <= 1) return rawLines

  const merged = [rawLines[0]]
  for (let i = 1; i < rawLines.length; i += 1) {
    const prev = merged[merged.length - 1]
    const next = rawLines[i]
    if (shouldMergeNewsLines(prev, next)) {
      merged[merged.length - 1] = joinNewsLines(prev, next)
    } else {
      merged.push(next)
    }
  }
  return merged
}

export function newsDateFromRecord(record) {
  const raw = record?.updated_at || record?.created_at || ''
  if (!raw) return ''
  return raw.slice(0, 10)
}
